import { get } from 'lodash-es';

import type { BlockEditFormSetter, ToggleFormField } from '../types';

export const createToggleField =
  (setFormValues: BlockEditFormSetter): ToggleFormField =>
  (field, fallback) =>
  () => {
    setFormValues((prev) => {
      const currentValue = get(prev, field, fallback);
      return { ...prev, [field]: !currentValue };
    });
  };
